import Button from "@mui/material/Button";
import { enqueueSnackbar } from "notistack";

function reload() {
	window.location.reload();
}

export const OpenVersionMessage = () => {
	enqueueSnackbar(
		"A new version is up! Please reload the app in order to get the newest features.",
		{
			persist: true,
			style: { backgroundColor: "#27262e", fontFamily: "Arimo", fontSize: 16 },
			// anchorOrigin: { vertical: "bottom", horizontal: "center" },

			action: () => (
				<Button size="small" style={{ margin: 8 }} onClick={reload}>
					RELOAD
				</Button>
			),
		}
	);
};
